import { render } from "./TwoFA.vue?vue&type=template&id=89b2b5c4&scoped=true"
import script from "./TwoFA.vue?vue&type=script&lang=js"
export * from "./TwoFA.vue?vue&type=script&lang=js"

import "./TwoFA.vue?vue&type=style&index=0&id=89b2b5c4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b2b5c4"]])

export default __exports__